import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

var _dec, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconStarSolid, IconStarLightSolid } from '@instructure/ui-icons';
import { themeable } from '@instructure/ui-themeable';
import { requestAnimationFrame } from '@instructure/ui-dom-utils';
import { Transition } from '@instructure/ui-motion';
var styles = {
  componentId: 'dTxVo',
  template: function template(theme) {
    return "\n\n.dTxVo_bGBk{display:inline-block;line-height:1;margin:0 ".concat(theme.iconMargin || 'inherit', ";vertical-align:bottom}\n\n.dTxVo_bGBk:first-of-type{margin-left:0}\n\n.dTxVo_bGBk:last-of-type{margin-right:0}\n\n.dTxVo_dnnz{display:inline-block;vertical-align:bottom}\n\n.dTxVo_fWJE .dTxVo_dnnz{color:").concat(theme.iconFilledColor || 'inherit', "}\n\n.dTxVo_eMrv .dTxVo_dnnz{color:").concat(theme.iconEmptyColor || 'inherit', "}\n\n.dTxVo_doqw .dTxVo_dnnz{font-size:").concat(theme.smallIconFontSize || 'inherit', "}\n\n.dTxVo_ycrn .dTxVo_dnnz{font-size:").concat(theme.mediumIconFontSize || 'inherit', "}\n\n.dTxVo_cMDj .dTxVo_dnnz{font-size:").concat(theme.largeIconFontSize || 'inherit', "}");
  },
  'root': 'dTxVo_bGBk',
  'icon': 'dTxVo_dnnz',
  'filled': 'dTxVo_fWJE',
  'empty': 'dTxVo_eMrv',
  'small': 'dTxVo_doqw',
  'medium': 'dTxVo_ycrn',
  'large': 'dTxVo_cMDj'
};
import theme from './theme';
/**
---
parent: DeprecatedRating
id: DeprecatedRatingIcon
---
**/

var RatingIcon = (_dec = themeable(theme, styles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(RatingIcon, _Component);

  function RatingIcon(props) {
    var _this;

    _classCallCheck(this, RatingIcon);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RatingIcon).call(this));
    _this._timeouts = [];

    _this.fill = function () {
      _this._animation = requestAnimationFrame(function () {
        _this.setState({
          filled: true
        });
      });
    };

    _this.handleTransitionEnter = function () {
      _this.applyTheme();
    };

    _this.state = {
      filled: props.filled && !props.animateFill
    };
    return _this;
  }

  _createClass(RatingIcon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.animateFill) {
        this._timeouts.push(setTimeout(this.fill, this.props.animationDelay));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.animateFill && this.props.filled && this.props.filled !== prevProps.filled) {
        this.fill();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._animation && this._animation.cancel();

      this._timeouts.forEach(function (timeout) {
        return clearTimeout(timeout);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var _this$props = this.props,
          size = _this$props.size,
          animateFill = _this$props.animateFill;
      var classes = (_classes = {}, _defineProperty(_classes, styles.root, true), _defineProperty(_classes, styles[size], true), _defineProperty(_classes, styles.filled, this.state.filled), _defineProperty(_classes, styles.empty, !this.state.filled), _classes);
      var Icon = this.state.filled ? IconStarSolid : IconStarLightSolid;
      return React.createElement("span", {
        className: classnames(classes)
      }, React.createElement("span", null, this.state.filled && animateFill ? React.createElement(Transition, {
        in: true,
        transitionOnMount: true,
        type: "scale",
        onEnter: this.handleTransitionEnter
      }, React.createElement(Icon, {
        className: styles.icon
      })) : React.createElement(Icon, {
        className: styles.icon
      })));
    }
  }]);

  RatingIcon.displayName = "RatingIcon";
  return RatingIcon;
}(Component), _class2.propTypes = {
  animationDelay: PropTypes.number,
  animateFill: PropTypes.bool,
  filled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
}, _class2.defaultProps = {
  animationDelay: 200,
  animateFill: false,
  filled: false,
  size: 'medium'
}, _temp)) || _class);
export default RatingIcon;
export { RatingIcon };